<template>
  <div class="fp_opt_subtitle_sm">
    {{ content }}
  </div>
</template>
<script>
export default {
  props: ["content"]
};
</script>
<style lang="scss">
@import "../../../../../../../resources/sass/_variables.scss";

.fp_opt_subtitle_sm {
  color: $mf_ft_color_lt;
  font-size: 1em;
}
</style>